import { processEnv } from '@utils/config';

export const H5_FE_SHOP_HOST_TEST = 'h5-fe-shop.meitun-test.com';
export const H5_FE_SHOP_HOST_PROD = 'h5-fe-shop.meitun.com';
export const APP_SHOP_HOST_TEST = 'm.meitun-test.com';
export const APP_SHOP_HOST_PROD = 'm.meitun.com';
export const NEXT_SHOP_TEST = 'shop.meitun-test.com';
export const NEXT_SHOP_PROD = 'shop.meitun.com';

export const H5_FE_SHOP_HOST = () => {
  if (processEnv.hostEnv === 'test') {
    return 'http://' + H5_FE_SHOP_HOST_TEST;
  } else {
    return 'https://' + H5_FE_SHOP_HOST_PROD;
  }
};

export const APP_SHOP_HOST = () => {
  if (processEnv.hostEnv === 'test') {
    return 'http://' + APP_SHOP_HOST_TEST;
  } else {
    return 'https://' + APP_SHOP_HOST_PROD;
  }
};

export const NEXT_SHOP_HOST = () => {
  if (processEnv.hostEnv === 'test') {
    return 'http://' + NEXT_SHOP_TEST;
  } else {
    return 'https://' + NEXT_SHOP_PROD;
  }
};
